// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"75511dbf","838":"323ab8d6"}[chunkId] + ".chunk.css";
};